import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaGithub, FaBars, FaTimes } from 'react-icons/fa';
import '../styles/navbar.css';
import '../styles/base.css';

const Navbar = ({ refs }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollTo = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false); // Close menu after clicking
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        {/* Brand logo - always visible */}
        <Link to="/" className="navbar-brand">
          <span className="brand-text">KH</span>
        </Link>

        {/* Mobile hamburger menu */}
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Desktop navigation links */}
        <div className="navbar-links desktop-only">
          {Object.entries(refs).map(([key, ref]) => (
            <span key={key} onClick={() => scrollTo(ref)} className="nav-item">
              {key}
            </span>
          ))}
        </div>

        {/* Mobile dropdown menu */}
        <div className={`mobile-dropdown ${isMenuOpen ? 'open' : ''}`}>
          {Object.entries(refs).map(([key, ref]) => (
            <span key={key} onClick={() => scrollTo(ref)} className="mobile-nav-item">
              {key}
            </span>
          ))}
        </div>

        {/* Social icons - always visible */}
        <div className="navbar-icons">
          <a href="https://www.linkedin.com/in/karstenhedrick/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn />
          </a>
          <a href="https://github.com/KarstenHedrick" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;